import { FC } from 'react';
import LoadingSpinner from '@/components/base/Loader/LoadingSpinner';
import { ActionType } from '@/interfaces/logging';
import { toClassNames } from '@/utils';

export const InitializingAppScreen: FC = () => {
  return (
    <div className={toClassNames('flex h-svh items-center justify-center', 'bg-revamp-cobalt-400')}>
      <LoadingSpinner
        loadingLogData={{
          action: ActionType.OnPageLoad,
          component: 'InitializingAppScreen',
          description: 'Loading initial app state',
        }}
      />
    </div>
  );
};
